import React, { useState, useEffect } from 'react';
import { Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, FormGroup, Label, CustomInput } from "reactstrap";
import { axiosApi } from '../Basicos/axiosInstances';
import { NewLoader } from '../Basicos';

const ModalSelecaoTipoAtividade = ({ 
    isOpen, 
    setIsOpen, 
    dados, 
    onSubmit, 
    periodoLetivoId 
}) => {
    const [tiposAtividade, setTiposAtividade] = useState([]);
    const [selecionados, setSelecionados] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const getTiposAtividade = async () => {
        if (!dados || !dados.tema_id) return;
        
        setIsLoading(true);
        try {
            const { data } = await axiosApi.get(`tipos-atividade-presentes?semestre_id=${dados.semestre_id}&periodo_letivo_id=${periodoLetivoId}&tema_id=${dados.tema_id}`);
            const atividades = data.dados || [];
            setTiposAtividade(atividades);
            
            // Inicia todos como selecionados por padrão
            const initialMap = {};
            atividades.forEach(tipo => {
                initialMap[tipo.id] = true;
            });
            setSelecionados(initialMap);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            getTiposAtividade();
        }
    }, [isOpen]);

    const handleCheckboxChange = (id) => {
        setSelecionados(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const handleSelectAll = (checked) => {
        const newSelecionados = {};
        tiposAtividade.forEach(tipo => {
            newSelecionados[tipo.id] = checked;
        });
        setSelecionados(newSelecionados);
    };

    const handleConfirm = () => {
        const idsSelecionados = Object.keys(selecionados).filter(id => selecionados[id]).map(id => parseInt(id));
        onSubmit(idsSelecionados);
        setIsOpen(false);
    };

    const isAllSelected = tiposAtividade.length > 0 && tiposAtividade.every(tipo => selecionados[tipo.id]);

    return (
        <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered size="md">
            <ModalHeader toggle={() => setIsOpen(false)}>
                Tipos de Atividade para Alocação
            </ModalHeader>
            <ModalBody>
                <NewLoader isActive={isLoading} overlay>
                    <div className="px-3">
                        <p className="mb-3">Selecione os tipos de atividade que deseja gerar/alocar:</p>
                        
                        <FormGroup check className="mb-3 pb-2 border-bottom">
                            <Label check>
                                <CustomInput
                                    type="checkbox"
                                    id="select-all"
                                    label="Selecionar Todos"
                                    checked={isAllSelected}
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                />
                            </Label>
                        </FormGroup>

                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            {Array.isArray(tiposAtividade) && tiposAtividade.map((tipo) => (
                                <FormGroup check key={tipo.id} className="mb-2">
                                    <Label check>
                                        <CustomInput
                                            type="checkbox"
                                            id={`tipo-${tipo.id}`}
                                            label={tipo.nome}
                                            checked={!!selecionados[tipo.id]}
                                            onChange={() => handleCheckboxChange(tipo.id)}
                                        />
                                    </Label>
                                </FormGroup>
                            ))}
                            {tiposAtividade.length === 0 && !isLoading && (
                                <p className="text-muted italic">Nenhum tipo de atividade encontrado para este tema.</p>
                            )}
                        </div>
                    </div>
                </NewLoader>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => setIsOpen(false)} className="btn-transparente">
                    Cancelar
                </Button>
                <Button 
                    color="primary" 
                    onClick={handleConfirm} 
                    disabled={Object.values(selecionados).every(v => !v) || isLoading}
                >
                    Confirmar Alocação
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalSelecaoTipoAtividade;
